// Territorio de San Roque: barrios del pueblo (nombre legal) y parajes rurales.
// Los nombres populares se traducen al legal: San Antonio y Jardín son San Francisco.
// El backend usa el mismo catálogo (backend/src/utils/barrios.js).

export const SAN_ROQUE_BARRIOS = [
  'Malvinas',
  'Urquiza',
  'Norte',
  'Centro',
  'Libertad',
  'Costanera',
  'San Francisco',
  'Arroyito',
]

// Parajes rurales confirmados (los mismos que reconoce la importación del padrón).
export const SAN_ROQUE_PARAJES = [
  'Arroyo Gonzalez',
  'Arroyo Paraiso',
  'Buena Vista',
  'Canada Mala',
  'Pairiri',
  'Santo Domingo',
  'Tacuaralito',
  '3ra Seccion',
]

// Parajes vecinos que no son de San Roque (su gente pertenece a otro municipio).
export const FUERA_DE_SAN_ROQUE = [
  'Colonia Pando', 'Mantilla', 'Santa Angelica', 'La Elisa', 'Pirayui',
  'Yazuca', 'Rosado Grande', 'Curtiembre', 'Boqueron',
]

export const BARRIO_OPTIONS = [...SAN_ROQUE_BARRIOS, ...SAN_ROQUE_PARAJES, 'Otro (especificar)']

const ALIASES = new Map([
  ['BARRIO MALVINAS', 'Malvinas'],
  ['MALVINAS ARGENTINAS', 'Malvinas'],
  ['BARRIO URQUIZA', 'Urquiza'],
  ['BARRIO NORTE', 'Norte'],
  ['BARRIO CENTRO', 'Centro'],
  ['BARRIO LIBERTAD', 'Libertad'],
  ['BARRIO COSTANERA', 'Costanera'],
  ['BARRIO SAN FRANCISCO', 'San Francisco'],
  ['SAN FCO', 'San Francisco'],
  // Nombres populares de San Francisco.
  ['SAN ANTONIO', 'San Francisco'],
  ['BARRIO SAN ANTONIO', 'San Francisco'],
  ['JARDIN', 'San Francisco'],
  ['BARRIO JARDIN', 'San Francisco'],
  ['BARRIO ARROYITO', 'Arroyito'],
])

const clave = (value) => String(value || '')
  .trim()
  .toUpperCase()
  .normalize('NFD')
  .replace(/[̀-ͯ]/g, '')
  .replace(/^(B[°º]|BO\.?|BARRIO|PARAJE)\s+/, (m) => (m.startsWith('PARAJE') ? '' : 'BARRIO '))
  .replace(/\s+/g, ' ')

export function normalizeBarrioLabel(value) {
  const normalized = clave(value)
  if (!normalized) return ''
  if (ALIASES.has(normalized)) return ALIASES.get(normalized)
  const sinPrefijo = normalized.replace(/^BARRIO /, '')
  const todos = [...SAN_ROQUE_BARRIOS, ...SAN_ROQUE_PARAJES]
  const exact = todos.find((item) => clave(item) === sinPrefijo)
  return exact || value
}

/** 'barrio' | 'paraje' | 'otro' — para agrupar el territorio en filtros y tableros. */
export function tipoLugar(value) {
  const n = normalizeBarrioLabel(value)
  if (SAN_ROQUE_BARRIOS.includes(n)) return 'barrio'
  if (SAN_ROQUE_PARAJES.includes(n)) return 'paraje'
  const clave = String(n).toUpperCase()
  if (FUERA_DE_SAN_ROQUE.some((x) => clave.includes(x.toUpperCase()))) return 'fuera'
  return 'otro'
}
